import mask from 'slim-mask-js';

export default function phoneNumberMask(str?: string): string {
  if (!str) return '';
  const string = str.replace(/\D/g, '');
  if (string.length <= 10) return mask(string, '(##) ####-####');
  return mask(string, '(##) # ####-####');
}
